<!-- SUMMARY -->
<div class="user-list-row-option" *ngIf="mode === 'summary'">
    <div fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <mat-form-field floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Prénom</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('Firstname')" mat-autoresize="true">
        </mat-form-field>
        <mat-form-field floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Nom</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('Lastname')" mat-autoresize="true">
        </mat-form-field>
        <div *ngIf="show('remove')" fxFlex="45px">
            <fa-icon (click)="removeUser()" [icon]="['fas', 'trash']" [styles]="{'color': 'gray'}" size="lg"></fa-icon>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <mat-form-field floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Code postal</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('Zip')" mat-autoresize="true">
        </mat-form-field>
        <mat-form-field floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Commune</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('City')" mat-autoresize="true">
        </mat-form-field>
    </div>
</div>
<!-- LIST -->
<div class="user-list-row-list-option" *ngIf="mode === 'list'">
    <div fxLayout="row" class="option-line">
        <!-- <div fxFlex="32px">
            <fa-icon [icon]="['fas','pencil']"></fa-icon>
        </div> -->
        <div fxFlex="32px">
            <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser.CNHealthAgent.CNDoctor'" [icon]="['fas', 'user-md']" [styles]="{'color': 'gray'}" size="lg"></fa-icon>
            <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser.CNPatient'" [icon]="['fas', 'user-injured']" [styles]="{'color': 'gray'}" size="lg"></fa-icon>
            <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser' && user.getProperty('Type') !== 'Group'" [icon]="['fas', 'user']" [styles]="{'color': 'gray'}" size="lg"></fa-icon>
            <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser' && user.getProperty('Type') === 'Group'" [icon]="['fas', 'users']" [styles]="{'color': 'gray'}" size="lg"></fa-icon>    
        </div>
        <div fxFlex><u>{{user.getProperty('Lastname')}}</u></div>
        <div fxFlex>{{user.getProperty('Firstname')}}</div>
        <div fxFlex="32px"><i class="fas" [ngClass]="{'fa-genderless': user.sex.type === 'unknown', 'fa-mars': user.sex.type === 'male', 'fa-venus': user.sex.type === 'female'}"></i></div>
    </div>
    <div fxLayout="row" class="option-line">
        <div fxFlex>{{user.getProperty('Birthday')}}</div>
        <div fxFlex>{{user.getProperty('NumSIS')}}</div>
    </div>
    <div fxLayout="row" class="option-line">
        <div fxFlex>{{user.getProperty('Adresse')}}</div>
    </div>
    <div fxLayout="row" class="option-line">
        <div fxFlex>{{user.getProperty('Localite')}}</div>
        <div fxFlex>{{user.getProperty('CodePostal')}}</div>
    </div>
    <div *ngIf="user.key === 'SNItem.SNUser.CNUser.CNHealthAgent.CNDoctor'" fxLayout="row" class="option-line">
        <div fxFlex>{{user.getProperty('INAMI')}}</div>
    </div>
</div>
<!-- ADMIN -->
<div class="user-list-row-list-option" *ngIf="mode === 'admin'">
    <div fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser.CNHealthAgent.CNDoctor'" [icon]="['fas', 'user-md']" fxFlex [styles]="{'color': 'gray'}" size="lg"></fa-icon>
        <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser.CNPatient'" [icon]="['fas', 'user-injured']" fxFlex [styles]="{'color': 'gray'}" size="lg"></fa-icon>
        <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser' && user.getProperty('Type') !== 'Group'" [icon]="['fas', 'user']" fxFlex [styles]="{'color': 'gray'}" size="lg"></fa-icon>
        <fa-icon *ngIf="user.key === 'SNItem.SNUser.CNUser' && user.getProperty('Type') === 'Group'" [icon]="['fas', 'users']" fxFlex [styles]="{'color': 'gray'}" size="lg"></fa-icon>
        <mat-form-field appearance="standard" floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Prénom</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('Firstname')" mat-autoresize="true">
        </mat-form-field>
        <mat-form-field appearance="standard" floatLabel="always" fxFlex class="field-full-width">
            <mat-label>Nom</mat-label>
            <input matInput class="mat-input-element-undisabled" disabled="true" [value]="user.getProperty('Lastname')" mat-autoresize="true">
        </mat-form-field>
    </div>
</div>